import { Style } from "../styles/types";
import { Post } from "../posts/types";
import { AclMemberDto } from "@/services/security/types";
import { RenderChannelModel } from "@/services/render/types";

export interface Channel {
    id: string,
    name: string,
    height: number,
    width: number,
    allowedPostTypes: Array<AllowedPostSettings>,
    items: Array<Post>,
    folderId: string,
    transitionType: string,
    interactionType: string,
    returnToFirstPostTime: number,
    menuStyleId: string | null,
    transitionTime: number,
    defaultShowTime: number,
    favorite: boolean,
    resolution: string,
    counterIndicator: boolean;
    durationIndicator: boolean;
    durationIndicatorStyleID: string | null;
    counterIndicatorStyleID: string | null;
}

export interface AllowedPostSettings {
    postType: string
}

export interface AllowedPostType {
    key: string,
    selected: boolean,
    isNew: boolean
}

export interface Settings {
    height: number,
    width: number,
    transitionType: string,
    interactionType: string,
    returnToFirstPostTime: number,
    menuStyleId: string | null,
    transitionTime: number,
    defaultShowTime: number,
    counterIndicator: boolean;
    durationIndicator: boolean;
    durationIndicatorStyleID: string | null;
    counterIndicatorStyleID: string | null;
}

export interface GroupSettings {
    name: string,
    height: number,
    width: number,
    behavior: string,
    interactionType: string,
    returnToFirstPostTime: number,
    menuStyleId: string | null,
    transitionType: string,
    transitionTime: number,
    showFirstPost: boolean,
    counterIndicator: boolean;
    durationIndicator: boolean;
    durationIndicatorStyleID: string | null;
    counterIndicatorStyleID: string | null;
}

export interface AddEditChannelDto {
    channel: Channel,
    acl: AclMemberDto[]
}

export interface ChannelPostTypeStyles {
    postType: string,
    itemTypeName: string,
    value: string,
    selected: boolean,
    styleId: string,
    disabled: boolean,
    styleable: boolean,
    styleOptions: Array<Style>
}

export interface ChannelPostOption {
    postType: string,
    selected: boolean,
    canBeStyled: boolean,
    styleId: string,
    styleOptions: Array<Style>
}

export interface ChannelGroup {
    id: string,
    name: string,
    width: number,
    height: number,
    behavior: ChannelGroupBehavior,
    folderId: string,
    postTypeStyles: Array<PostTypeStyle>,
    transitionType: string,
    interactionType: string,
    returnToFirstPostTime: number,
    menuStyleId: string | null,
    transitionTime: number,
    channelGroupChannels: Array<ChannelGroupChannel>,
    showFirstPost: boolean,
    counterIndicator: boolean;
    durationIndicator: boolean;
    durationIndicatorStyleID: string | null;
    counterIndicatorStyleID: string | null;
}

export interface ChannelGroupResolution {
    width: number;
    height: number;
    display: string;
}

export interface PostTypeStyle {
    postType: string,
    styleId: string
}

export interface ChannelGroupItemTypeStyles {
    itemTypeName: string,
    value: string,
    selected: boolean,
    styleId: string,
    styleable: boolean,
    styleOptions: Array<Style>
}

export interface ChannelGroupChannel {
    channelId: string,
    channelName: string,
    order: number,
    width: number,
    height: number,
    folderId: string,
    showTime: number,
    selected: boolean;
}

export interface ChannelGroupChannelDrag {
    channelId: string,
    channelName: string,
    order: number,
    width: number,
    height: number,
    folderId: string,
    showTime: number,
    selected: boolean;
    active: boolean;
    activeDropTarget: boolean;
}

export enum ChannelGroupBehavior {
    Sorted = "Sorted",
    Queue = "Queue",
    Random = "Random"
}

export interface ChannelDto {
    id: string,
    name: string,
    width: number,
    height: number,
    styleId: string
}

export interface ChannelSize {
    width: number,
    height: number,
    display: string
}

export interface ChannelStyle {
    width: number,
    height: number,
    css: {}
}

export interface ChannelsFilterDtoIn {
    templateId: string,
    solutionId: string,
    channelGroupId: string,
    postType:string,
    resolution: string,
    folderId: string,
    search: string
    flatList: boolean
}

export interface ChannelInfo {
    name: string,
    height: number,
    width: number,
    folderPath: string,
    types: Array<AllowedPostSettings>,
    templates: Array<InfoValue>,
    backgrounds: Array<InfoValue>,
    solutions: Array<InfoValue>,
    channelGroups: Array<InfoValue>,
    stages: Array<InfoValue>,
}

export interface InfoValue {
    id: string,
    name: string,
    hasPermission: boolean
}

export interface CopyChannel {
    channelId: string,
    name: string,
    width: number,
    height: number,
    copyContent: boolean,
    copyUserAccess: boolean,
}

export interface ChannelGroupsFilterDtoIn {
    templateId: string,
    solutionsId: string
}

export interface ChannelGroupInfo {
    name: string,
    height: number,
    width: number,
    folderPath: string,
    templates: Array<InfoValue>,
    backgrounds: Array<InfoValue>,
    solutions: Array<InfoValue>,
    stages: Array<InfoValue>
}

export interface CopyChannelGroup {
    channelGroupId: string,
    name: string,
    width: number,
    height: number,
    copyChannels: boolean,
}

export enum TransitionTypes {
    none = "none",
    fade = "fade",
    tickerUp = "tickerUp",
    tickerLeft = "tickerLeft",
    tickerRight = "tickerRight",
    tickerDown = "tickerDown"
}

export enum InteractionTypes {
    none = "none",
    menu = "menu",
    menuFlat = "menuFlat"
}

export function isShift(model: RenderChannelModel) {
    const interactionTypes = InteractionTypes;
    if (model.interactionType === interactionTypes.none || model.interactionType === "" || model.interactionType === undefined || model.interactionType === null) return true;
    return false;
}

export enum ChannelStyleTypes {
    duration = "duration",
    counter = "counter",
    menuStyle = "menuStyle",
    all = "all" // used only for the "no style" option in front end
}
